const state = {
  eventlist: [],
  search: "",
  total: -1,
  page: 1,
  filter: [],
  date_range: {
    type: '',
    start: '',
    end: ''
  },
  month_events: [],
  categorylist: {},
  loading: false
}

export default state
